export const platformVersion = '^22.0.0';
